<template>
  <div class="creation-demand-step-week">
    <VeeForm ref="form" @submit="save">
      <h2 class="step-title">
        {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@WEEK_TITLE")) }}
      </h2>
      <div class="creation-week-selection">
        <IconBoxWrapper icon="icon-f-clock">
          <Field
            v-slot="{ errors, field, value }"
            v-model="weeklyHours[ICreationStepWeeklyHours.hours]"
            :name="$filters.formLabelValidation($t('ETAB.PAGES.DEMANDS.CREATION.@WEEK_FORM_LABEL')).replace(' ', '_')"
            :rules="weeklyHours.isFluctuating() && weeklyHours.getHours() === undefined ? {} : { max_value: MAX_HOURS, min_value: 1, numeric: true }"
          >
            <QInput
              v-bind="field"
              :model-value="value"
              stack-label
              :placeholder="35"
              type="number"
              class="q-mx-sm q-mb-sm"
              :label="$t('ETAB.PAGES.DEMANDS.CREATION.@WEEK_FORM_LABEL')"
              :suffix="$t('ETAB.PAGES.DEMANDS.CREATION.@WEEK_FORM_SUFFIX')"
              :error="errors.length > 0"
              :error-message="errors[0]"
              @update:model-value="setHours(parseInt($event))"
            />
          </Field>
        </IconBoxWrapper>

        <IosCheckbox
          :model-value="weeklyHours.isFluctuating()"
          :label="$t('ETAB.PAGES.DEMANDS.CREATION.@WEEK_FORM_FLUCTUATING')"
          :left-label="true"
          class="q-mt-md"
          @update:model-value="setFluctuating($event)"
        />
      </div>
      <transition appear enter-active-class="animated fadeIn slower delay-1s" leave-active-class="animated fadeOut">
        <section class="q-footer q-layout__section--marginal fixed-bottom">
          <div>
            <QBtn
              color="secondary"
              class="full-width btn-navigation"
              :label="$t('ETAB.BUTTONS.@NEXT')"
              no-caps
              type="submit"
              :loading="loading"
              :disabled="!isWeeklyHoursNotNull"
            />
          </div>
        </section>
      </transition>
    </VeeForm>
  </div>
</template>

<script>
  import { CreationStepPlanningModel, ICreationStepPlanning, ICreationStepWeeklyHours } from "@core/models";

  import { Form as VeeForm, Field } from "vee-validate";
  import { localize } from "@vee-validate/i18n";

  const MAX_HOURS = 42;

  export default {
    components: {
      VeeForm,
      Field,
    },
    props: {
      transition: {
        type: Boolean,
        required: false,
      },
      stepData: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["saveStep"],
    data() {
      return {
        weeklyHours: new CreationStepPlanningModel(),
      };
    },
    computed: {
      hours() {
        return this.weeklyHours[ICreationStepWeeklyHours.hours];
      },
      isWeeklyHoursNotNull() {
        return (this.hours > 0 && this.hours <= MAX_HOURS) || this.weeklyHours.isFluctuating();
      },
    },
    mounted() {
      // Here we override generic field error for max_value vee validate rule
      // we need to specify a valid field name, "semaine_de" in our case
      // see https://vee-validate.logaretm.com/v4/guide/i18n#custom-messages-for-specific-fields
      const fieldName = this.$filters.formLabelValidation(this.$t("ETAB.PAGES.DEMANDS.CREATION.@WEEK_FORM_LABEL")).replace(" ", "_");
      localize("fr", {
        fields: {
          [fieldName]: {
            max_value: this.$t("ETAB.PAGES.DEMANDS.CREATION.@WEEK_FORM_MAX_CUSTOM_ERROR"),
            min_value: this.$t("ETAB.PAGES.DEMANDS.CREATION.@WEEK_FORM_MIN_CUSTOM_ERROR"),
          },
        },
      });
    },
    created() {
      this.MAX_HOURS = MAX_HOURS;
      this.ICreationStepWeeklyHours = ICreationStepWeeklyHours;
      this.weeklyHours = new CreationStepPlanningModel(this.stepData);
    },
    methods: {
      goToPlanning() {
        this.save({
          [ICreationStepWeeklyHours.weeklyHours]: undefined,
        });
      },
      setHours(value) {
        this.weeklyHours[ICreationStepWeeklyHours.hours] = value;
        if (value && value > 0 && value <= MAX_HOURS) {
          this.weeklyHours[ICreationStepWeeklyHours.fluctuating] = false;
        }
      },
      setFluctuating(value) {
        this.weeklyHours[ICreationStepWeeklyHours.fluctuating] = value;
        if (!!value) {
          this.weeklyHours[ICreationStepWeeklyHours.hours] = undefined;
        }
      },
      save() {
        // save weekly hours informations
        this.$emit("saveStep", {
          [ICreationStepPlanning.hours]: this.weeklyHours.getHours(),
          [ICreationStepPlanning.fluctuating]: this.weeklyHours.isFluctuating(),
        });
      },
    },
  };
</script>

<style lang="scss">
  .creation-demand-step-week {
    .extra-tipbox {
      margin-top: 40px;
    }
  }
</style>
